import { ReactElement } from 'react';
import { Chip } from '@weareopenr/component-library';
import { IMenuLabel } from 'src/api/getMenuLabels';

/** Read-only chips for the labels on a menu or menu set. */
export const menuLabelChips = (menuLabels: IMenuLabel[]): ReactElement<{ label: string }>[] =>
  menuLabels.map(({ menu_label_id, name }) => (
    <Chip key={menu_label_id} label={name} icon="pricing" backgroundColour="blueberry" />
  ));
